import { Link } from '@compat/router';
import './index.scss';
import type { FC, ReactElement } from 'react';
import { memo } from 'react';

interface MainProps {
  heading: string;
  src: string;
  text?: string | ReactElement<any>;
}

interface ButtonMainBannerProps extends MainProps {
  onClick: () => void;
  btnText: string;
  href?: never;
}

interface LinkMainBannerProps extends MainProps {
  btnText: string;
  href: string;
  onClick?: never;
}

type MainBannerProps = ButtonMainBannerProps | LinkMainBannerProps;

const MainBanner: FC<MainBannerProps> = ({
  heading,
  src,
  btnText,
  text,
  ...props
}) => (
  <div
    className='MainBanner'
    style={{
      backgroundImage: `url(${src})`
    }}
  >
    <div className='MainBanner__content'>
      <h1 className='MainBanner__heading'>{heading}</h1>
      {text && <div className='MainBanner__text'>{text}</div>}
      {props.onClick && (
        <button className='MainBanner__btn' onClick={props.onClick}>
          {btnText}
        </button>
      )}
      {props.href && (
        <Link className='MainBanner__btn' to={props.href}>
          {btnText}
        </Link>
      )}
    </div>

    <div className='MainBanner__dark-bg' />
  </div>
);

export default memo(MainBanner);
